module.exports = __webpack_public_path__ + "static/img/12.121dcb4d.jpg";